type Address = {
  street: string;
  addressNumber: string;
  postalCode: string;
  municipality: string;
  region: string;
};

export const COVIE_APPLICATION_UPLOAD = (
  name: string,
  firstName: string,
  lastName: string,
  email: string,
  address: Address,
  buildingUnit: string,
  documentLink: string,
) => `mutation {
  applicationUpload(
    input: {
      documentLink: "${documentLink}",
      name: "${name}",
      firstName: "${firstName}",
      lastName: "${lastName}",
      email: "${email}",
      buildingUnit: "${buildingUnit}",
      address :{
        street: "${address.street}",
        addressNumber: "${address.addressNumber}",
        postalCode: "${address.postalCode}",
        municipality: "${address.municipality}",
        region: ${address.region}
      }
    }
  ) {
    ...on ApplicationOutput {
        id
        status
    }
    ...on ErrorListOutput {
      errors{
        type
        message
      }
    }
  }
}
`;
